<template>
  <div class="confirm-order-container">
    <div class="order-container">
      <div class="confirm-title">
        <div class="confirm-official-title">确认收货地址</div>
        <div class="confirm-sub-title" @click="toAddAddress">
          <img src="../../assets/edit.svg" alt="" />
          <span>添加收货地址</span>
        </div>
      </div>
      <!-- 地址 -->
      <div class="area-container">
        <div
          class="area-item"
          :class="{ active: item.isSelect }"
          v-for="item in addressList"
          :key="item.id"
          @click="toSelectArea(item)"
        >
          <div>
            <i class="el-icon-location" v-if="item.isSelect"></i>
            <span class="send-to" v-if="item.isSelect">寄送至</span>
            <el-radio
              v-model="item.radio"
              :label="item.id"
              class="area-radio"
              >{{ item.addressName }}</el-radio
            >
          </div>
          <div class="edit-area" v-if="item.isSelect" @click="toEditAddress(item)">修改本地址</div>
        </div>
      </div>
      <div class="confirm-title">
        <div class="confirm-official-title">确认订单信息</div>
      </div>
      <div class="order-table-container">
        <el-table
          :data="tableData"
          style="width: 100%"
          header-align="center"
          header-row-class-name="order-table-header"
        >
          <el-table-column prop="info" label="商品信息" width="420">
            <template slot-scope="scope">
              <div class="order-item">
                <img :src="scope.row.img" alt="" class="order-item-img" />
                <div>
                  <div class="order-item-name">{{ scope.row.name }}</div>
                  <div class="order-item-category" >
                    <span v-for="(value,key) in scope.row.spec" :key="key" style="margin-right:4px;">
                      {{ `${key}:${value}` }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价" align="center">
            <template slot-scope="scope">
              <div class="order-item-price">{{ scope.row.price }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="数量" align="center"  width="220">
            <template slot-scope="scope">
              <!-- max 库存最大值 -->
              <el-input-number
                v-model="scope.row.count"
                :min="1"
                :max="scope.row.stock"
                @change="value=>countChange(value,scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="total"
            label="小计"
            align="center"
          >
            <template slot-scope="scope">
              <div class="order-item-price primary">￥{{ scope.row.total }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="msg-delivery">
          <!-- 留言区 -->
          <div class="msg-container">
            <span>给卖家留言：</span>
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              :max-length="200"
              show-word-limit
              placeholder="请输入留言内容"
              v-model="remark"
              style="flex: 1"
            >
            </el-input>
          </div>
          <div class="order-item-delivery">运送方式: 快递 满99元包邮</div>
          <div class="order-item-price delivery-money">{{ deliveryFee }}</div>
        </div>
      </div>
    </div>
    <div class="order-total-container">
        <div class="order-item-price">
            合计（含运费）：<span class="order-item-price primary">
                ¥{{totalIncludeFreight}}
            </span>
        </div>
        <div class="order-address-user">
            <div class="order-item-price">
                <span style="margin-right:10px;">
                    寄送至：
                    <span class="order-text">{{ selectAddress ? selectAddress.addressName : '' }}</span>
                </span>
                <span>
                    收货人：
                    <span class="order-text">{{ `${selectAddress ? selectAddress.name:''} ${selectAddress ? selectAddress.phone :''}` }}</span>
                </span>
            </div>
            <div class="order-tip">
                请仔细核对收货信息，提交后不可提交
            </div>
        </div>
    </div>
    <div class="order-btn-container">
        <div class="submit-order-btn" @click="toSubmitOrder">提交订单</div>
    </div>
    <AddressDialog v-if="isShowAddress" :dialogTitle="dialogTitle" :addressInfo="addressInfo" @closeDialog="closeAddressDialog"></AddressDialog>
    <PayDialog v-if="isShowPay"  :confirmInfo="confirmInfo" @closeDialog="closePayDialog"></PayDialog>
  </div>
</template>

<script>
import { getAddressList } from "@/api/home"
import AddressDialog from './addressDialog.vue'
import Decimal from "decimal.js"
import { mapState } from "vuex"
import PayDialog from './payDialog.vue'
export default {
  components:{ AddressDialog,PayDialog },
  data() {
    return {
      goodsInfo: null,
      addressList: [],
      selectAddress:null, //选中的地址信息
      isShowAddress:false,
      dialogTitle:'',
      addressInfo:null,
      tableData: [],
      deliveryFee:'',//运费
      totalIncludeFreight:0,
      remark:'', //留言
      isShowPay:false,
      confirmInfo:null
    };
  },
  computed:{
    ...mapState("company",['company'])
  },
  created() {
    window.scrollTo(0,0)
    if (localStorage.getItem("goodsInfo")) {
      this.goodsInfo = JSON.parse(localStorage.getItem("goodsInfo"));
    }
    this.getAddressList()
    this.getOrderList()
  },
  destroyed() {
    // remove localStorage goodsInfo
  },
  methods: {
    closePayDialog() {
      this.confirmInfo = null
      this.isShowPay = false
    },
    toSubmitOrder() {
      console.log(this.selectAddress,this.$route.params.isCart)
      const goods_data = this.goodsInfo.map(item=>{
        return {
          goods_sku_id:item.skuId,
          count:item.count
        }
      })
      this.confirmInfo = {
        address_id:this.selectAddress.id,
        remark:this.remark,
        is_cart:this.goodsInfo[0].isCart,
        goods_data
      }
      this.isShowPay = true
      console.log(this.confirmInfo,'confirmInfo')
    },
    getTotalIncludeFreight() {
      let totalPrice = 0
      this.tableData.forEach(item=>{
        console.log(item,'item')
        totalPrice = new Decimal(totalPrice).add(new Decimal(item.total)).toNumber()
        this.totalIncludeFreight = totalPrice
      })
      if(this.company.free_delivery_min) {
        if(totalPrice >= +this.company.free_delivery_min ) {
          this.deliveryFee = '免邮'
        }else {
          this.deliveryFee = `￥${this.company.delivery_fee}`
          this.totalIncludeFreight  = new Decimal(this.totalIncludeFreight).add(new Decimal(this.company.delivery_fee)).toNumber() 
        }
      }
    },
    countChange(value,item) {
      item.total = new Decimal(item.price).mul(new Decimal(value))
      this.getTotalIncludeFreight()
    },
    // 获取订单信息
    getOrderList() {
      let totalPrice = 0
      const orderList = localStorage.getItem('goodsInfo')
      this.tableData = orderList ? JSON.parse(orderList) : []
      this.tableData.forEach(item=>{
        item.total = new Decimal(item.price).mul(new Decimal(item.count)).toNumber()
        totalPrice = new Decimal(totalPrice).add(new Decimal(item.total)).toNumber()  //获取所有详情的小计之和
        this.totalIncludeFreight = totalPrice
      })
      if(this.company.free_delivery_min) {
        if(totalPrice >= +this.company.free_delivery_min ) {
          this.deliveryFee = '免邮'
        }else {
          this.deliveryFee = `￥${this.company.delivery_fee}`
          this.totalIncludeFreight  = new Decimal(this.totalIncludeFreight).add(new Decimal(this.company.delivery_fee)).toNumber() 
        }
      }
      console.log(totalPrice,'total')
    },
    toEditAddress(address) {
      this.dialogTitle = '修改本地址'
      this.addressInfo = address
      this.isShowAddress = true
    },
    closeAddressDialog(data) {
      this.dialogTitle = ''
      this.addressInfo = null
      this.isShowAddress = false
      if(data == true) {
        // 重新获取地址列表
        this.getAddressList()
      }
    },
    // 添加新地址
    toAddAddress() {
      this.dialogTitle = '添加新地址'
      this.isShowAddress = true
    },
    //获取我的地址
    async getAddressList() {
        const { data } = await getAddressList()
        this.addressList = data
        const item = data.find(item=>item.is_default == 1) // 是否有设置默认地址
        if(item) {
            this.$set(item,'isSelect',true)
            this.$set(item,'radio',item.id)
            this.selectAddress = item
        }else {
            this.$set(this.addressList[0],'isSelect',true)
            this.$set(this.addressList[0],'radio',this.addressList[0].id)
            this.selectAddress = this.addressList[0]
        }
        this.addressList.forEach(item=>{
            item.addressName = `${item.province}${item.city}${item.district}${item.address}(${item.name} 收) ${item.phone}`
        })
    },
    toSelectArea(item) {
      this.addressList.forEach((area) => {
        if (area.id === item.id) {
          area.radio = item.id;
          area.isSelect = true;
          this.selectAddress = area
        } else {
          area.radio = "";
          area.isSelect = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
@import "~@/styles/mixin.less";
.confirm-order-container {
  width: 1200px;
  margin: 25px auto 0;
}
.order-container {
  width: 100%;
  border-radius: 20px;
  background: #fff;
  padding: 31px 47px 0;
  box-sizing: border-box;
}
.confirm-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #e3e3e3;
  padding: 0 19px 16px;
}
.confirm-official-title {
  font-size: 20px;
  font-weight: 600;
  color: @words;
  line-height: 28px;
}
.confirm-sub-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: @words;
  cursor:pointer;
  > img {
    margin-right: 5px;
  }
}
.area-container {
  margin-top: 29px;
  margin-bottom: 48px;
}
.area-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  padding-left: 112px;
}
.area-item.active {
  background: #fff0e8;
  border: 1px solid #ff4400;
  padding-left: 12px;
}
.el-icon-location {
  color: #ff4400;
  font-size: 20px;
}
.send-to {
  font-size: 14px;
  font-weight: 600;
  color: @words;
  line-height: 20px;
  margin-left: 12px;
  margin-right: 25px;
}
.edit-area {
  font-size: 14px;
  font-weight: 600;
  color: @primary;
  line-height: 20px;
  cursor: pointer;
}
.order-table-container {
  margin-top: 20px;
  margin-left: 19px;
  padding-bottom: 48px;
}
.order-th {
  height: 60px;
  line-height: 60px;
  padding-bottom: 50px;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 600;
  color: @words;
}
.order-item {
  display: flex;
}
.order-item-img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  margin-right: 26px;
}
/deep/.el-table__cell.is-leaf {
  text-align: center;
}
/deep/.el-table thead {
  font-size: 16px;
  font-weight: 600;
  color: @words !important;
}
.order-item-name {
  font-size: 14px;
  font-weight: 600;
  color: @words;
  .line-clamp();
}
.order-item-category {
  font-size: 12px;
  font-weight: 400;
  color: @tipwords;
  margin-top: 21px;
  .line-clamp(1);
}
.msg-delivery {
    display: flex;
    align-items:center;
}
.msg-container {
  display: flex;
  margin-top: 21px;
}
.msg-container span {
  width: 90px;
  text-align: right;
  font-size: 12px;
  font-weight: 400;
  color: @tipwords;
  margin-right: 20px;
}
.msg-container /deep/ .el-textarea__inner {
  border-radius: 10px;
  border: 1px solid #e3e3e3;
  width: 310px;
}
.msg-container /deep/ .el-textarea__inner::placeholder {
  font-size: 14px;
  font-weight: 400;
  color: @tipwords;
}
.order-item-price {
  font-size: 20px;
  font-weight: 600;
  color: @words;
}
.order-item-price.primary {
    color:@primary;
}
.order-item-delivery {
  font-size: 14px;
    font-weight: 400;
    color: @tipwords;
    margin-left: 75px;
}
.delivery-money {
    margin-left: 264px;
    color: @primary;
}
/deep/.el-table .el-table__cell {
    padding: 25px 0;
    border-bottom: none;
}
/deep/.el-table th.el-table__cell {
    border-bottom: none;
}
.order-total-container{
    background: #FFFFFF;
    border-radius: 20px;
    margin-top: 55px;
    padding: 33px 46px;
    box-sizing: border-box;
    text-align: right;
}
.order-address-user {
    margin-top:16px;
}
.order-text {
    color: @tipwords;
    font-weight: normal;
}
.order-tip {
    color: @tipwords;
    font-size: 20px;
}
.order-btn-container {
    display: flex;
    justify-content: flex-end;
}
.submit-order-btn {
    margin-top: 55px;
    margin-right: 29px;
    width: 191px;
    height: 64px;
    background: #3998FE;
    border-radius: 14px;
    padding: 18px 20px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 153px;
    cursor: pointer;
}
</style>
<style>
.area-radio {
  font-weight: 400;
  color: #333333;
}
</style>